import occoApi from './occoAPI.js';
import LANG from '../lang/prop_en.js';
import { MEDIA_TYPE_IMAGE, MEDIA_TYPE_VIDEO } from './constants.js';

const SETTINGS_PARAMS_END_USER = [
  'UX_SHOW_COUNTDOWN_BEFORE_SHOOTING',
  'UX_DELAY_WHILE_SHOWING_PICTURE',
  'UX_SOUND_ALLOW',
  'UX_COUNTDOWN_DELAY_MS',
  'UX_USE_QR_CODE_BASED_IMAGE_ACCESS',
  'UX_DISPLAY_RECENT_PHOTOS_STRIP',
  'UX_EXPIRE_PHOTO_ICON_STRIP_MINUTES',
];
const SETTINGS_PARAMS_PHOTO_DIST = [
  'SHARING_OCCO_ALBUM_NAME',
  'SHARING_UPLOAD_TO_OCCO_CLOUD',
  'MEDIA_DO_RUN_SCRIPT_ON_IMAGE_CAPTURE',
];
const SETTINGS_PARAMS_CAMERA = [
  'CAMERA_SHUTTER_SPEED',
  'CAMERA_ISO_AUTO_DETECT',
  'CAMERA_EXPOSURE_COMP',
  'CAMERA_ISO_MAX_AT_DISTANCE',
  'CAMERA_ISO_INDEX_MIN',
  'CAMERA_ISO_INDEX_MAX',
];
const SETTINGS_PARAMS_ADMIN = ['ADMIN_MAIN_EMAIL', 'ADMIN_CC_EMAIL', 'ADMIN_LOW_DISK_SPACE_WARNING_GB'];
const SETTINGS_PARAMS_PERSON_TRACK = [
  /* "FACE_MAY_USE",
     "FACE_REQUIRED_TO_SHOOT",
     "FACE_PID_MULTIPLIER",
     "FACE_ACCEL_SCALER",
     "DEPTH_MAX_SKELETON_DISTANCE",
     "FACE_MINIMUM_SIZE",
     "UX_DO_NOT_SHOOT_WITHOUT_GESTURE" */
];
const SETTINGS_PARAMS_WATERMARK = [
  'WATERMARK_FILE_LIVE_VIEW_S3_PATH',
  'WATERMARK_FILE_SENT_PHOTOS_S3_PATH',
  'WATERMARK_FILE_LIVE_VIEW',
  'WATERMARK_FILE_LIVE_VIEW_UPDATED',
  'WATERMARK_FILE_SENT_PHOTOS',
  'WATERMARK_FILE_SENT_PHOTOS_UPDATED',
];
const ERROR_CODES = {
  ROBOT_NAME_IS_ALREADY_EXIST:
    "{robot_name} can't be created as it already exists in {org_name} Organization. Please choose a different name.",
};
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address

export function getErrorMessage(code) {
  let message = code;
  if (ERROR_CODES[code] !== undefined) {
    message = ERROR_CODES[code];
  }
  return message;
}

export function hashDiff(h1, h2) {
  const d = {};
  for (const k in h2) {
    if (h1[k] !== h2[k]) d[k] = h2[k];
  }
  return d;
}

export function isBlank(str) {
  return str === null || str === undefined || str === '';
}

export function tryJson(str, defaultVal) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultVal;
  }
}

export function convertSerializedArrayToHash(a) {
  const r = {};
  for (let i = 0; i < a.length; i++) {
    r[a[i].name] = $.trim(a[i].value);
  }
  return r;
}

export function getRoleNameById(id) {
  let name = '';
  switch (id) {
    case 1:
      name = 'Super Admin';
      break;
    case 2:
      name = 'Admin';
      break;
    case 3:
      name = 'Viewer';
      break;
  }
  return name;
}

export function populate(frm, data) {
  $.each(data, (key, value) => {
    const $obj = $(`[name=${key}]`);
    if ($obj.length > 0) {
      if ($obj.attr('type') === 'checkbox') {
        $(`[name=${key}]`, frm).prop('checked', value != 0);
      }
      $(`[name=${key}]`, frm).val(value);
    }
  });
}

export function seperateOtherParamsArray(data) {
  const arr = [];
  $.each(data, (key, value) => {
    if (
      key !== 'robot' &&
      key !== 'IS_LOCAL_CONFIG_UPDATED' &&
      SETTINGS_PARAMS_END_USER.indexOf(key) == -1 &&
      SETTINGS_PARAMS_PHOTO_DIST.indexOf(key) == -1 &&
      SETTINGS_PARAMS_CAMERA.indexOf(key) == -1 &&
      SETTINGS_PARAMS_ADMIN.indexOf(key) == -1 &&
      SETTINGS_PARAMS_PERSON_TRACK.indexOf(key) == -1 &&
      SETTINGS_PARAMS_WATERMARK.indexOf(key) == -1
    ) {
      arr.push(key);
    }
  });
  return arr;
}

export function copyToClipboard(text) {
  window.prompt('OCCO Robot ID', text);
}

export function is_Super() {
  const role = Storage.getLocalItem('role');
  if (role === '1') {
    return true;
  }
  return false;
}

export function is_Admin() {
  const role = Storage.getLocalItem('role');
  if (role === '2') {
    return true;
  }
  return false;
}

export function updatePermissions() {
  if (!is_Super()) {
    $('.SUPERUSER').hide();
    if (!is_Admin()) {
      $('.ADMINUSER').hide();
    }
  }
}

export var Storage = {
  setLocalItem(key, value) {
    localStorage.setItem(key, value);
  },

  getLocalItem(key) {
    return localStorage.getItem(key);
  },

  removeLocalItem(key) {
    localStorage.removeItem(key);
  },
};

String.prototype.replaceAll = function (search, replacement) {
  const target = this;
  return target.split(search).join(replacement);
};

export function escStr(str) {
  str = str.replace(/(<([^>]+)>)/gi, '');
  return str;
}

String.prototype.escape = function () {
  const tagsToReplace = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
  };
  return this.replace(/[&<>]/g, (tag) => tagsToReplace[tag] || tag);
};

export function importHtmlFiles(callback) {
  jQuery(document).ready(() => {
    callback();
  });
}
$.fn.serializeObject = function () {
  const o = {};
  const a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name] !== undefined) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  const $radio = $('input[type=radio],input[type=checkbox]', this);
  $.each($radio, function () {
    if (!o.hasOwnProperty(this.name)) {
      o[this.name] = this.value ? parseInt(this.value) : '';
    }
  });
  return o;
};

export function fromUrlFilename(url) {
  if (!url) {
    return url;
  }
  return url.split('/').pop();
}

export function normaliseUrl(url) {
  if (!url) {
    return url;
  }
  const fileName = fromUrlFilename(url);
  return url.replace(fileName, '') + encodeURIComponent(fileName);
}

export function generateRandomFileName(originalFileName) {
  let fileType = '';
  if (originalFileName && originalFileName.lastIndexOf('.') != -1) {
    fileType = originalFileName.substr(originalFileName.lastIndexOf('.') + 1);
  }

  const res = `${Math.random().toString(36).substring(7)}.${fileType}`;
  return res;
}

export function generateTid2() {
  return (Date.now()-(new Date('2017-01-01').getTime()))*8192 + Math.floor(Math.random() * 8192);
}

export function uploadImage(formId, imageContId, progresId, valInputId) {
  const form = $(`#${formId}`);
  form.fileupload({
    url: form.attr('action'),
    type: 'POST',
    datatype: 'xml',
    add(event, data) {
      let fileName = data.files[0].name;
      fileName = fileName.replace(/\s/g, '');
      let rootPath = 'tmp/';
      const fileRelativePath = `${rootPath + generateTid2()}/${fileName}`;
      occoApi.assetTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
        if (err) {
          return alert(err.message_key);
        }
        $(`#${formId}`).attr('action', result.url);
        $(`#${formId} input[name=key]`).val(fileRelativePath);
        $(`#${formId} input[name=Content-Type]`).val(data.files[0].type);
        $(`#${formId} input[name=X-Amz-Credential]`).val(result.fields['X-Amz-Credential']);
        $(`#${formId} input[name=X-Amz-Algorithm]`).val(result.fields['X-Amz-Algorithm']);
        $(`#${formId} input[name=X-Amz-Date]`).val(result.fields['X-Amz-Date']);
        $(`#${formId} input[name=X-Amz-Security-Token]`).val(result.fields['X-Amz-Security-Token']);
        $(`#${formId} input[name=Policy]`).val(result.fields.Policy);
        $(`#${formId} input[name=X-Amz-Signature]`).val(result.fields['X-Amz-Signature']);

        // Message on unLoad.
        window.onbeforeunload = function () {
          return LANG.unsaved_message;
        };
        // Submit
        data.submit();
      });
    },
    send(e, data) {
      // onSend
    },
    progress(e, data) {
      const percent = Math.round((data.loaded / data.total) * 100);
      $(`.bar${progresId}`).css('width', `${percent}%`);
    },
    fail(e, data) {
      // Remove 'unsaved changes' message.
      window.onbeforeunload = null;
      $(`.bar${progresId}`).css('width', `${0}%`);
    },
    success(data) {
      // onSuccess
      const filePath = $(data).find('Key')[0].childNodes[0].nodeValue;
      const originalSrc = `${window.ASSET_PATH}/${filePath}`;
      $(`#${imageContId}`).attr('src', normaliseUrl(originalSrc));
      $(`#${valInputId}`).attr({ href: normaliseUrl(originalSrc) });
      $(`#${valInputId}`).show('a');
      $(`#hidden${valInputId}`).val(originalSrc);
    },
    done(event, data) {},
  });
}

export function activateMultiEmail(id) {
  $(`#${id}`).tagsInput({
    width: 'auto',
    pattern: emailRegex,
    defaultText: 'Email', // default: false
    height: '35px',
  });
}

export function fixPopupOverlays() {
  $(document).on('show.bs.modal', '.modal', function () {
    const zIndex = 1040 + 10 * $('.modal:visible').length;
    $(this).css('z-index', zIndex);
    setTimeout(() => {
      $('.modal-backdrop')
        .not('.modal-stack')
        .css('z-index', zIndex - 1)
        .addClass('modal-stack');
    }, 0);
  });
}
fixPopupOverlays();

export function deleteBg(bg) {
  $(`#${bg}`).attr('src', '');
  $(`#hidden${bg}Path`).val('');
  $(`#${bg}Path`).hide('a');
}

export function getShortListByComma(list) {
  const arrList = list.split(',');
  let shortedList = `<span title='${list}'>`;
  if (arrList.length > 3) {
    for (let i = 0; i < 3; i++) {
      shortedList += `${arrList[i]},`;
    }
    shortedList += '...';
  } else {
    shortedList += list;
  }

  shortedList += '</span>';
  return shortedList;
}

/** @param {string} id */
export function elById(id) {
  return $(`#${id}`);
}

export const isChecked = (selector) => +$(selector).is(':checked');

export function isEmptyList(list) {
  return !Array.isArray(list) || !list.length;
}

export function mediaType(contentType) {
  if (contentType.indexOf('image') !== -1) {
    return MEDIA_TYPE_IMAGE;
  }
  if (contentType.indexOf('video') !== -1) {
    return MEDIA_TYPE_VIDEO;
  }
  return undefined;
}

export function detectMediaType(src) {
  if (src.match(/\.(jpeg|jpg|gif|png)$/) != null) {
    return MEDIA_TYPE_IMAGE;
  }
  if (src.match(/\.(mp4|webm|ogg|mov)$/) != null) {
    return MEDIA_TYPE_VIDEO;
  }
  return undefined;
}

export function hasExtension(ext, path) {
  return path?.toLowerCase().endsWith(ext) || false;
}

export function showElement(selector) {
  $(selector).show();
}

export function hideElement(selector) {
  $(selector).hide();
}
